export default {
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  primary: {
    main: '#1EED9F',
    light: '#C9FFEB',
    contrastText: '#222822',
  },
  secondary: {
    main: '#DEF1F4',
    dark: '#88C81A',
    light: '#018094',
    contrastText: '#222822',
  },
  warning: {
    main: '#EFAB00',
    light: '#FFF8C1',
  },
  info: {
    main: '#0C95EB',
    dark: '#757DBB',
    light: 'rgba(46, 96, 170, 0.25)',
    contrastText: '#222822',
  },
  success: {
    main: '#88C81A',
    light: '#E5F6EF',
    contrastText: '#222822',
  },
  error: {
    main: '#EB484E',
    light: 'rgba(235, 72, 78, 0.48)',
    dark: '#D1272D',
    contrastText: '#222822',
  },
  text: {
    primary: '#303642',
    secondary: '#687285',
    disabled: '#949DB0',
  },
  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
    image: '#5B65AB29',
    labelGrey: '#949DB029',
    popoverItem: '#949DB014',
    tableRow: '#5B65AB14',
    popoverRed: '#FDE3E4',
    popoverRedHover: '#FDCBCD',
    popoverGreen: '#EDFBCC',
    popoverGreenHover: '#DAF79F',
  },
  action: {
    hover: 'rgba(148, 157, 176, 0.08)',
    disabled: '#BBC9DF',
    selected: 'rgba(91, 101, 171, 0.08)',
    disabledBackground: '#BBC9DF',
    disabledOpacity: 1,
  },
  grey: {
    100: '#DDDDEA',
    120: 'rgba(148, 157, 176, 0.12)',
    200: '#EFEFF4',
    300: 'rgba(145, 158, 171, 0.24)',
    400: 'rgba(148, 157, 176, 0.32)',
    500: 'rgba(148, 157, 176, 0.48)',
    600: 'rgba(104, 114, 133, 0.56)',
    700: '#DCE0E8',
    800: '#9F9F9F',
  },
};
